import React from 'react';
import { Link } from 'react-router-dom';

const RoadMapCTimelines = () => {
    return ( 
        <div className="section-padding bg-color-body">
				<div className="container">
					<div className="section-heading section-heading--center  col-MB-60">
						{/* <!--<h5 class="__subtitle">NUESTRO CAMINO</h5>--> */}
						<h2 className="__title">Roadmap CTimelines</h2>
					</div>

					<div className="row row--xs-middle">
						<div className="col col--md-10">
							{/* <!-- start timeline --> */}
							<div className="timeline timeline--style-2 timeline--dark-color">

								{/* <!-- start item --> */}
								<div className="__item __item--active __item--current">
									<i className="__point"></i>
									<span className="__line __line--active"></span>

									
									<span className="__text __text--first">
									July 2022
									</span>									
									<h5 className="__text __text--second">
									<a target='_blank' rel="noopener noreferrer" href="https://visualcardano.com/">
									Visual Cardano Contest (1st place)
									</a>
									</h5>
									

									<p>
									The first edition of the Cardano Timeline is published.
									</p>
								</div>
								{/* <!-- end item --> */}

								{/* <!-- start item --> */}
								<div className="__item __item--active __item--current">
									<i className="__point"></i>
									<span className="__line __line--active"></span>

									<span className="__text __text--first">
									August 2022
									</span>
									<h5 className="__text __text--second">
									<a target='_blank' rel="noopener noreferrer" href="https://www.youtube.com/watch?v=-tH5TlZIwt4&ab_channel=IndividuoDigital">
									Collaboration | Individuo Digital (Youtube channel)
									</a>
									</h5>

									<p>
									Ep. 142: TIMELINE de Cardano
									</p>
								</div>
								{/* <!-- end item --> */}

								{/* <!-- start item --> */}
								<div className="__item __item--active __item--current">
									<i className="__point"></i>
									<span className="__line __line--active"></span>

									{/* <span className="__text __text--first">August 2022</span> */}
									<h5 className="__text __text--second">
									<a target='_blank' rel="noopener noreferrer" href="https://www.youtube.com/watch?v=8QYH9GkoGJI&ab_channel=LatinStakePools">
									Collaboration | Latin Stake Pools (Youtube channel)
									</a>
									</h5>

									<p>
									Jotape nos presenta su Cardano Timeline
									</p>
								</div>
								{/* <!-- end item --> */}

								{/* <!-- start item --> */}
								<div className="__item __item--active __item--current">
									<i className="__point"></i>
									<span className="__line __line--active"></span>

									<span className="__text __text--first">
									September 2022
									</span>
									<h5 className="__text __text--second">
									<a target='_blank' rel="noopener noreferrer" href="https://doc.ctimelines.io/es-cardano-timelines/eventos/cardano-plutus-hackathon-bsas-argentina-2022/stand-cardano-timeline">
									Cardano Plutus Hackathon (event)
									</a>
									</h5>

									<p>
									CTimelines booth
									</p>
								</div>
								{/* <!-- end item --> */}

								{/* <!-- start item --> */}
								<div className="__item __item--active __item--current">
									<i className="__point"></i>
									<span className="__line __line--active"></span>

									<span className="__text __text--first">
									November 2022
									</span>
									<h5 className="__text __text--second">
									<a target='_blank' rel="noopener noreferrer" href="https://doc.ctimelines.io/es-cardano-timelines/eventos/cardano-summit-2022-bsas-argentina">
									Cardano Summit 2022 BsAs Argentina (event)
									</a>
									</h5>

									<p>
									CTimelines booth
									</p>

								</div>
								{/* <!-- end item --> */}

								{/* <!-- start item --> */}
								<div className="__item __item--active">
									<i className="__point"></i>
									<span className="__line __line--active"></span>

									<span className="__text __text--first">
									February 2023
									</span>
									<h5 className="__text __text--second">
									<a target='_blank' rel="noopener noreferrer" href="https://ctimelines.io/cardano-timeline-2022">
									Cardano Timeline 2022 NFT Collection
									</a>
									</h5>

									<p>
									Infographic key changes:<br></br>
									- Key scalability optimizations introduced with the Vasil hard fork.
									</p>
								</div>
								{/* <!-- end item --> */}

								{/* <!-- start item --> */}
								<div className="__item __item--active __item--current">
									<i className="__point"></i>
									<span className="__line __line--active"></span>

									<span className="__text __text--first">
									March 2023
									</span>
									<h5 className="__text __text--second">
									<a target='_blank' rel="noopener noreferrer" href="https://ctimelines.io/cardano-timeline-2022">
									Web Portal CTimelines.io
									</a>
									</h5>

									<p>
										 
									</p>
								</div> 
								{/* <!-- end item --> */}

								{/* <!-- start item --> */}
								<div className="__item __item--active __item--current">
									<i className="__point"></i>
									<span className="__line __line--active"></span>

									{/* <span className="__text __text--first">March 2023</span> */}
									<h5 className="__text __text--second">
									<a target='_blank' rel="noopener noreferrer" href="https://www.youtube.com/watch?v=j55tt3oaOAI&ab_channel=Bitcoinparatodos">
									Collaboration | Bitcoin para Todos (podcast)
									</a>
									</h5>

									<p>
									Cardano Timeline: La historia de Cardano	 
									</p>
								</div>
								{/* <!-- end item --> */}

								{/* <!-- start item --> */}
								<div className="__item __item--active __item--current">
									<i className="__point"></i>
									<span className="__line __line--active"></span>

									{/* <span className="__text __text--first">March 2023</span> */}
									<h5 className="__text __text--second">
									<a target='_blank' rel="noopener noreferrer" href="https://issuu.com/carnadarevista/docs/carnada_1_-_ctimelines">
									Collaboration | Carnada (Digital Magazine)
									</a>
									</h5>

									<p>
									CTimelines (Carnada #1) article	 
									</p>
								</div>
								{/* <!-- end item --> */}								

								{/* <!-- start item --> */}
								<div className="__item __item--active __item--current">
									<i className="__point"></i>
									<span className="__line __line--active"></span>

									{/* <span className="__text __text--first">March 2023</span> */}
									<h5 className="__text __text--second">
									<a target='_blank' rel="noopener noreferrer" href="https://www.youtube.com/watch?v=u0Jh8xcdH4g&ab_channel=IndividuoDigital">
									Collaboration | Individuo Digital (Youtube channel)
									</a>
									</h5>

									<p>
									Ep. 203: Cardano Timelines 
									</p>
								</div>
								{/* <!-- end item --> */}

								{/* <!-- start item --> */}
								<div className="__item __item--active __item--current">
									<i className="__point"></i>
									<span className="__line __line--active"></span>

									<span className="__text __text--first">
									April 2023
									</span>
									<h5 className="__text __text--second">
									<a target='_blank' rel="noopener noreferrer" href="https://cardanospot.io/news/cardano-timeline-2022">
									Cardano Spot Content Competition (4th place)
									</a>
									</h5>

									<p>
										 
									</p>
								</div> 
								{/* <!-- end item --> */}

								{/* <!-- start item --> */}
								<div className="__item __item--active __item--current">
									<i className="__point"></i>
									<span className="__line __line--active"></span>

									<span className="__text __text--first">
									July 2023
									</span>
									<h5 className="__text __text--second">
									<a target='_blank' rel="noopener noreferrer" href="https://cardano.ideascale.com/c/idea/102971">
									Project Catalyst Fund10
									</a>
									</h5>

									<p>
									CTimelines Infographics<br></br>
									Documenting & Promoting Cardano's History<br></br>
									Proposal Submission	(NOT funded)
									</p>
								</div> 
								{/* <!-- end item --> */}

								{/* <!-- start item --> */}
								<div className="__item __item--active __item--current">
									<i className="__point"></i>
									<span className="__line __line--active"></span>

									<span className="__text __text--first">
									November 2023
									</span>
									<h5 className="__text __text--second">
									Global Presence at Cardano Summit 2023
									</h5>

									<p>
									1. Buenos Aires, Argentina<br></br>
									2. Curitiba, Brasil<br></br>
									3. Vancouver, Canada<br></br>
									4. London, United Kingdom<br></br>
									5. Oslo, Norway<br></br>
									6. Seoul, South Korea<br></br>
									</p>
								</div> 
								{/* <!-- end item --> */}

								{/* <!-- start item --> */}
								<div className="__item __item--active __item--current">
									<i className="__point"></i>
									<span className="__line __line--active"></span>

									

									<h5 className="__text __text--second">									
									<Link to={process.env.PUBLIC_URL + "/cardano-timeline-2023"}>Cardano Timeline 2023</Link>								
									</h5>

									<p>
									Infographic key changes:<br></br>
									- DApps emerged as Goguen Phase (smart contracts) matured.
									</p>
								</div>
								{/* <!-- end item --> */}

								{/* <!-- start item --> */}
								<div className="__item __item--active __item--current">
									<i className="__point"></i>
									<span className="__line __line--active"></span>

									<span className="__text __text--first">
									July 2024
									</span>
									<h5 className="__text __text--second">
									<a target='_blank' rel="noopener noreferrer" href="https://cardano.ideascale.com/c/idea/121119">
									Project Catalyst Fund12
									</a>
									</h5>

									<p>
									CTimelines Infographics<br></br>
									Documenting & Promoting Cardano's History<br></br>
									Proposal Submission	(NOT funded)
									</p>
								</div> 
								{/* <!-- end item --> */}

								{/* <!-- start item --> */}
								<div className="__item __item--active __item--current">
									<i className="__point"></i>
									<span className="__line __line--active"></span>

									<span className="__text __text--first">
									November 2024
									</span>
									<h5 className="__text __text--second">									
									<Link to={process.env.PUBLIC_URL + "/cardano-timeline-2024"}>Cardano Timeline 2024</Link>								
									</h5>

									<p>
									Infographic key changes:<br></br>
									- Events leading up to the Voltaire (Governance) phase added.
									</p>
								</div>
								{/* <!-- end item --> */}

								{/* <!-- start item --> */}
								<div className="__item __item--active __item--current">
									<i className="__point"></i>
									<span className="__line __line--active"></span>

									<span className="__text __text--first">
									December 2024
									</span>
									<h5 className="__text __text--second">									
									<a target='_blank' rel="noopener noreferrer" href="https://x.com/InputOutputHK/status/1865163496712773827">
									Constitutional Convention
									</a>						
									</h5>

									<p>
									School of Law, University of Buenos Aires (UBA), Argentina
									</p>
								</div>
								{/* <!-- end item --> */}								

								{/* <!-- start item --> */}
								<div className="__item __item--active __item--current">
									<i className="__point"></i>
									<span className="__line __line--active"></span>

									<span className="__text __text--first">
									January 2025
									</span>									

									<h5 className="__text __text--second">
									<Link to={process.env.PUBLIC_URL + "/research-timeline-2025"}>Research Timeline 2025</Link>	
									</h5>

									<p>
									Infographic focused on the most relevant research papers and specifications that laid the foundation for the development of the Cardano blockchain.
									</p>
								</div>
								{/* <!-- end item --> */}

																{/* <!-- start item --> */}
								<div className="__item __item--active __item--current">
									<i className="__point"></i>
									<span className="__line"></span>

									<span className="__text __text--first">
									July 2025
									</span>									

									<h5 className="__text __text--second">
									<Link to={process.env.PUBLIC_URL + "/cardano-timeline-2025"}>Cardano Timeline 2025</Link>	
									</h5>

									<p>
									Infographic key changes:<br></br>
									- Phases order updated to align with CIP-59.<br></br>
									- Bitcoin DeFi and L2/Partner Chains added.
									</p>
								</div>
								{/* <!-- end item --> */}							
								
						</div>
					</div>
				</div>
			</div>
        </div>
    )
}

export default RoadMapCTimelines;